import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Heading, Paragraph } from '@scentregroup/ui'
import classNames from 'classnames'
import IconRow from '../../icon-row'
import GetDirections from './get-directions'
import StoreLink from './store-link'
import style from './index.scss'

const showDirections = (latitude, longitude) =>
  latitude !== null && longitude !== null

const numberOfStores = stores => {
  if (Array.isArray(stores)) {
    return stores.length
  } else {
    return 0
  }
}

const ParkingZone = props => {
  const bestParkingFor = (props.bestParkingFor || []).filter(store => store)
  return (
    <div className={classNames(props.className, style.parkingZone)}>
      <Heading type="small">{props.carParkName}</Heading>
      <div className={style.location}>
        <IconRow
          className={style.locationPin}
          text={props.carParkLocation}
          icon="location-drop-pin"
        />
        <div className={style.availabilityDirections}>
          {showDirections(props.latitude, props.longitude) && (
            <GetDirections
              className={style.getDirections}
              latitude={props.latitude}
              longitude={props.longitude}
            />
          )}
        </div>
      </div>
      <div className={style.lower}>
        <Paragraph>Entrance on {props.carParkEntrance}</Paragraph>
        <Paragraph className={style.nearestStores}>
          {bestParkingFor && bestParkingFor.length > 0 && 'Nearest stores '}
          {(bestParkingFor || []).map((store, counter, stores) => (
            <Fragment key={store.sys.id}>
              <StoreLink
                key={`${props.centreSlug}-${store.sys.id}`}
                store={store}
                centreSlug={props.centreSlug}
              />
              {counter < numberOfStores(stores) - 1 && ', '}
            </Fragment>
          ))}
        </Paragraph>
      </div>
    </div>
  )
}

ParkingZone.propTypes = {
  carParkName: PropTypes.string,
  carParkLocation: PropTypes.string,
  carParkEntrance: PropTypes.string,
  bestParkingFor: PropTypes.array,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  centreSlug: PropTypes.string,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

export default ParkingZone
